import React, { useState, useEffect } from "react";
import { PDFViewer, PDFDownloadLink, StyleSheet } from "@react-pdf/renderer";
import { useParams } from "react-router";
import axios from "axios";
import '../../../Styles/Components/Dashboards/Report/Pree_Pdf_Viewer.css';
import isTokenExpired from '../../PublicForms/isTokenExpired.js';
import { useNavigate } from "react-router-dom";
import Config from "../../PublicForms/Config.js";
import LoaderComp from "../../PublicForms/Loader.js";
import Pdf_Report_All_Person from "./Pdf_Report_All_Person.js";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#d11fb6",
    color: "white",
  },
  section: {
    margin: 10,
    padding: 10,
  },
  viewer: {
    width: '100vw',
    height: '100vh',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
});

const Pree_Pdf_Report_All_Person = () => {
  const [loading, setLoading] = useState(true);
  const [width, setWidth] = useState(0);
  const Navigate = useNavigate();
  const [runFilterDbPersons, setRunFilterDbPersons] = useState(true);
  const [printData, setPrintData] = useState([]);
  const [message, setMessage] = useState([]);
  const [messTitle, setMessTitle] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const { degree, province, city } = useParams();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        Navigate("/login");
      }
    } else {
      Navigate("/login");
    }
  }, []);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // دریافت لیست اشخاص با پارامترهای معتبر
  useEffect(() => {
    const getListAllPersons = async () => {
      // ساخت تمیز و ایمن Query String
      const degreeQuery = degree && degree !== '-' ? `&degree=${encodeURIComponent(degree)}` : '';
      const provinceQuery = province && province !== '-' ? `&province=${encodeURIComponent(province)}` : '';
      const cityQuery = city && city !== '-' ? `&city=${encodeURIComponent(city)}` : '';
      
      const requestUrl = `${Config.apiBaseUrl}/api/Person?which=true${degreeQuery}${provinceQuery}${cityQuery}`;

      axios.get(requestUrl, {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
        }
      }).then(response => {
        if (response.status === 200) {
          setPrintData(response.data);
          setLoading(false);
        } else {
          setLoading(false);
          setMessTitle("خطا");
          setMessage((prevMessages) => [
            ...prevMessages,
            "لطفا مجددا تلاش کنید",
          ]);
          setShowDialog(true);
        }
      }).catch((err) => {
        setLoading(false);
        console.error(err);
        if (err.response) {
          setMessage([]);
          if (err.response.status === 401) {
            Navigate("/login");
          } else if (err.response.status === 400) {
            setMessTitle("خطای اعتبارسنجی");
            // استخراج خطاهای validation اگر وجود داشته باشد
            const errorsObj = err.response.data?.errors;
            if (errorsObj) {
              const errorList = Object.values(errorsObj).flat();
              setMessage(errorList);
            } else {
              setMessage([err.response.data?.title || "درخواست نامعتبر است"]);
            }
            setShowDialog(true);
          } else if (err.response.status === 500) {
            setMessTitle("خطا");
            setMessage((prevMessages) => [
              ...prevMessages,
              err.response.data?.detail || "خطای سرور",
            ]);
            setShowDialog(true);
          } else {
            setMessTitle("خطا");
            setMessage((prevMessages) => [
              ...prevMessages,
              "لطفا مجددا تلاش کنید",
            ]);
            setShowDialog(true);
          }
        } else if (err.message === "Network Error") {
          setMessTitle("خطا");
          setMessage((prevMessages) => [
            ...prevMessages,
            "برقراری ارتباط با سرور امکان پذیر نمی باشد",
          ]);
          setShowDialog(true);
        } else {
          setMessTitle("خطا");
          setMessage((prevMessages) => [
            ...prevMessages,
            "لطفا مجددا تلاش کنید",
          ]);
          setShowDialog(true);
        }
      });

      setRunFilterDbPersons(false);
    };

    if (runFilterDbPersons === true) {
      getListAllPersons();
    }
  }, [runFilterDbPersons]);

  // ۱. حالت در حال لودینگ
  if (loading) {
    return (
      <div className="personLst">
        <p className="personLst-loader-txt">لطفا چند لحظه صبر کنید...</p>
        <div className="personLst-loader">
          <LoaderComp />
        </div>
      </div>
    );
  }

  // ۲. در صورت بروز خطا
  if (showDialog) {
    return (
      <div className="pree-factor-error" style={{ textAlign: "center", padding: "20px" }}>
        <h3>{messTitle}</h3>
        {message.map((msg, index) => (
          <p key={index} style={{ color: "red" }}>{msg}</p>
        ))}
      </div>
    );
  }

  // ۳. در صورتی که دیتایی وجود نداشته باشد
  if (!printData || (Array.isArray(printData) && printData.length === 0)) {
    return (
      <div className="pree-factor-empty" style={{ textAlign: "center", padding: "20px" }}>
        <p>داده‌ای برای گزارش‌گیری یافت نشد.</p>
      </div>
    );
  }

  // ۴. رندر نسخه دسکتاپ و موبایل
  if (width > 768) {
    return (
      <div className='pree-factor' style={styles.viewer}>
        <div className="pdf" style={styles.viewer}>
          <PDFViewer width="100%" height="100vh" style={styles.viewer}>
            <Pdf_Report_All_Person printData={printData} />
          </PDFViewer>
        </div>
      </div>
    );
  } else {
    return (
      <div className='pree-factor'>
        <div className="pdf">
          <PDFDownloadLink
            className="pdf-download"
            document={<Pdf_Report_All_Person printData={printData} />}
            fileName='reportAllPersonsMouood.pdf'
          >
            {({ loading: pdfLoading }) =>
              pdfLoading ? 'در حال آماده‌سازی فایل PDF...' : 'دانلود'
            }
          </PDFDownloadLink>
        </div>
      </div>
    );
  }
};

export default Pree_Pdf_Report_All_Person;
